import React from 'react';
import { LANGUAGE } from './languages';
import contentProvider from '../../content/contentProvider';

export const LanguageContext = React.createContext({
  language: LANGUAGE.MN,
  changeLanguage: () => {},
});

export const LanguageProvider = Component => {
  return class LanguageProvider extends React.Component {
    constructor(props) {
      super(props);
      this.state = { language: this.loadLanguage() };
    }

    changeLanguage = lang => {
      this.persistLanguage(lang);
      this.setState({ language: lang });
    };

    loadLanguage = () => {
      const lang = localStorage.getItem('lang');
      if (lang in LANGUAGE) {
        return lang;
      } else {
        return LANGUAGE.MN;
      }
    };

    persistLanguage = lang => {
      localStorage.setItem('lang', lang);
    };

    render() {
      return (
        <LanguageContext.Provider
          value={{
            language: this.state.language,
            changeLanguage: this.changeLanguage,
            content: contentProvider(this.state.language),
          }}
        >
          <Component {...this.props} />
        </LanguageContext.Provider>
      );
    }
  };
};

export const withLanguage = Component => props => (
  <LanguageContext.Consumer>
    {language => <Component {...props} {...language} />}
  </LanguageContext.Consumer>
);
